import axios from "axios";
import { env } from "../config/env";

const apiUrl = env.API_BASE_URL;

const instance = axios.create({
  baseURL: apiUrl,
  timeout: 300000,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    if (config.headers) delete (config.headers as any).Authorization;
  }
  return config;
});

export function setAuthToken(token?: string | null) {
  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete instance.defaults.headers.common.Authorization;
  }
}

let isLoggingOut = false;

// --- Função central de logout, sem usar o axios instance (evita loop)
async function performLogout() {
  if (isLoggingOut) return;
  isLoggingOut = true;

  localStorage.removeItem("token");
  window.location.reload()

  // try {
  //   let redirect = "https://login.microsoftonline.com/logout";

  //   const res = await fetch(`${apiUrl}/auth/logout`, {
  //     method: "POST",
  //   });

  //   if (res.ok) {
  //     const data = await res.json().catch(() => ({}));
  //     redirect = data?.logoutUrl || redirect;
  //   }

  //   localStorage.removeItem("token");
  //   window.location.href = redirect;
  // } catch {
  //   localStorage.removeItem("token");
  //   window.location.href = "https://login.microsoftonline.com/logout";
  // }
}

// --- Interceptor de resposta: 401 => logout
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.code === "ERR_CANCELED" || error?.name === "AbortError") {
      console.warn("Axios request canceled:", error?.message);
      return Promise.resolve();
    }

    const status = error?.response?.status;
    const url: string | undefined = error?.config?.url;

    // Evita loop se a própria rota de logout falhar com 401
    const isLogoutCall = url?.includes("/auth/logout");

    if (status === 401 && !isLogoutCall) {
      // Dispara logout (uma única vez)
      performLogout();
      // Retorna promessa pendente para interromper a cadeia (a página vai redirecionar)
      return new Promise(() => { });
    }

    return Promise.reject(error);
  }
);

export default instance;
